// Hook odpowiedzialny za tworzenie koszyka na podstawie ostatniego zamówienia

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

// typ zwracanych danych
interface IResponse extends ICommandResponseSuccess {
  data: {
    id: number;
  };
}

const postCartFromLastOrder = (): Promise<IResponse> =>
  axios.post('/carts/from-last-order', {});

export const usePostCartFromLastOrder = (options?: UseMutationOptions<IResponse, IError>) =>
  useMutation(() => postCartFromLastOrder(), options);
